import { SvgIconProps } from "@mui/material";
import { ThemedFillSvgIcon } from "src/theme-mui/components/svg-icon/themed-fill-svg-icon";

export const IconNoData = ({ ...props }: SvgIconProps) => (
    <ThemedFillSvgIcon {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="141" height="116" viewBox="0 0 141 116" fill="none">
            <g clipPath="url(#clip0_2500_22931)">
                <path
                    d="M43.7502 4.19678L45.0702 7.8651C45.6818 9.56065 47.0161 10.8967 48.7134 11.5084L52.3818 12.8283L48.7134 14.1483C47.0179 14.76 45.6818 16.0942 45.0702 17.7916L43.7502 21.4599L42.4303 17.7916C41.8186 16.096 40.4843 14.76 38.787 14.1483L35.1187 12.8283L38.787 11.5084C40.4825 10.8967 41.8186 9.56244 42.4303 7.8651L43.7502 4.19678Z"
                    stroke="#333333"
                    strokeWidth="2.30769"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M88.1583 65.5142L81.8823 59.2382L96.8739 44.2465C100.016 41.1041 100.016 36.0067 96.8739 32.8642C93.7314 29.7217 88.634 29.7217 85.4916 32.8642L70.4999 47.8558L55.5083 32.8642C52.3658 29.7217 47.2684 29.7217 44.1259 32.8642C40.9834 36.0067 40.9834 41.1041 44.1259 44.2465L59.1176 59.2382L44.1259 74.2298C40.9834 77.3723 40.9834 82.4697 44.1259 85.6122C45.698 87.1843 47.7567 87.9695 49.8171 87.9695C51.8775 87.9695 53.9361 87.1843 55.5083 85.6122L70.4999 70.6205L85.4916 85.6122C87.0637 87.1843 89.1223 87.9695 91.1827 87.9695C93.2431 87.9695 95.3017 87.1843 96.8739 85.6122C100.016 82.4697 100.016 77.3723 96.8739 74.2298"
                    fill="#D5E6A5"
                />
                <path
                    d="M88.1583 65.5142L81.8823 59.2382L96.8739 44.2465C100.016 41.1041 100.016 36.0067 96.8739 32.8642C93.7314 29.7217 88.634 29.7217 85.4916 32.8642L70.4999 47.8558L55.5083 32.8642C52.3658 29.7217 47.2684 29.7217 44.1259 32.8642C40.9834 36.0067 40.9834 41.1041 44.1259 44.2465L59.1176 59.2382L44.1259 74.2298C40.9834 77.3723 40.9834 82.4697 44.1259 85.6122C45.698 87.1843 47.7567 87.9695 49.8171 87.9695C51.8775 87.9695 53.9361 87.1843 55.5083 85.6122L70.4999 70.6205L85.4916 85.6122C87.0637 87.1843 89.1223 87.9695 91.1827 87.9695C93.2431 87.9695 95.3017 87.1843 96.8739 85.6122C100.016 82.4697 100.016 77.3723 96.8739 74.2298"
                    stroke="#333333"
                    strokeWidth="2.30769"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M53.0813 8.27215C58.5453 6.4049 64.4046 5.39258 70.5 5.39258C100.238 5.39258 124.346 29.5005 124.346 59.2387C124.346 88.977 100.238 113.085 70.5 113.085C40.7617 113.085 16.6538 88.977 16.6538 59.2387C16.6538 42.8127 24.0101 28.1036 35.6071 18.2272"
                    stroke="#333333"
                    strokeWidth="2.30769"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2500_22931">
                    <rect width="140" height="115.385" fill="white" transform="translate(0.5 0.307617)" />
                </clipPath>
            </defs>
        </svg>
    </ThemedFillSvgIcon>
);
